import { CollectionStory } from "./CollectionModel";

export class StoryModalInfo {
  show: boolean = false;
  story: CollectionStory = null;
}